import React, { Component } from "react";
import { Router, Switch, Route } from "react-router-dom";

import Login from "./pages/Login";
import Steps from "./pages/Steps";
import Dashboard from "./pages/Dashboard";
import NotFound from "./pages/NotFound";

import history from './history';

export default class Routes extends Component {
    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route path='/Login' render={(props) => (<Login {...props} />)}/>
                    <Route path='/Steps' render={(props) => (<Steps {...props} />)}/>
                    <Route path="/" component={Dashboard} />
                    <Route component={NotFound} />
                </Switch>
            </Router>
        )
    }
}